import { useEffect, useContext, lazy, Suspense } from "react";
import "./App.css";

import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "./Context/UserContext";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
import Loading from "./components/Loading/Loading";
// import Navbar from "./components/Header/Navbar";
import NavbarWithoutUser from "./components/Header/NavbarWithoutUser";
import SignIn from "./Pages/auth/SignIn";
import SignUp from "./Pages/auth/SignUp";
import ResetPassword from "./Pages/auth/ResetPassword";
import Navbar from "./components/Header/Navbar";
import Profile from "./Pages/profile/Profile";
import NewProfile from "./Pages/profile/NewProfile";
import EditProfile from "./Pages/profile/EditProfile";
import EditPassword from "./Pages/profile/EditPassword";
import Home from "./Pages/Home";
import CategorySearch from "./Pages/CategorySearch";
import Play from "./Pages/movies/Play";
import Mylist from "./Pages/Mylist";
import PlaySerie from "./Pages/series/PlaySerie";
import PermissionsTest from "./Pages/PermissionsTest";
import RequireAuth from "./hooks/RequireAuth";
import PlayVideo from "./Pages/PlayVideo";
import EditProfilePassword from "./Pages/profile/EditProfilePassword";
import Search from "./Pages/Search";
import Subscription from "./Pages/subscription/Subscription";
import Payment from "./Pages/subscription/Payment";
import ResetPwdPage from "./Pages/auth/ResetPwdPage";
import Conditions from "./components/Footer/Conditions";
import Politics from "./components/Footer/Politics";
import FAQ from "./components/Footer/FAQ";
import MySubscription from "./Pages/profile/MySubscription";
import GuestLayout from "./hooks/GuestLayout";
import RequireSubAuth from "./hooks/RequireSubAuth";
import LandingRedirect from "./Pages/LandingRedirect";

const Welcome = lazy(() => import("./Pages/Welcome"));


function App() {
  const { user, setUser } = useContext(AuthContext);
  // useEffect(() => {
  //   const auth = getAuth();
  //   onAuthStateChanged(auth, (user) => {
  //     setUser(user);
  //   });
  // }, []);

  return (
    <div>
      {/* {User ? <Navbar></Navbar> : <NavbarWithoutUser></NavbarWithoutUser>} */}
      {/* <NavbarWithoutUser></NavbarWithoutUser> */}
      {/* <Navbar></Navbar> */}
      <Suspense replace fallback={<Loading />}>
        <Routes>
          {/* <Route path="/" element={user ? <RequireAuth element={Home} /> : <Welcome />} /> */}
          {/* <Route index path="/" element={<RequireAuth element={Welcome}/>} /> */}
          <Route
            path="/"
            element={
              user.id ? <Navigate to="/home" replace /> : <LandingRedirect />
              // user.id ? <Navigate to="/home" replace /> : <Welcome />
            }
          />
          {/* <Route path="/#/landing" element={<LandingRedirect />} /> */}
          <Route path="/home" element={<RequireSubAuth element={Home} />} />
          <Route path="/signin" element={<GuestLayout element={SignIn} />} />
          <Route path="/signup" element={<GuestLayout element={SignUp} />} />
          <Route path="/profile" element={< RequireAuth element={Profile} />} />
          <Route path="/new-profile" element={< RequireAuth element={NewProfile} />} />
          <Route path="/edit-profile" element={<RequireAuth element={EditProfile} />} />
          <Route path="/edit-password" element={<RequireAuth element={EditPassword} />} />
          <Route path="/my-subscription" element={<RequireSubAuth element={MySubscription} />} />
          <Route path="/edit-profile-password" element={<RequireAuth element={EditProfilePassword} />} />
          <Route path="/:categoryName" element={<RequireSubAuth element={CategorySearch} />} />
          <Route path="/:categoryName/:subcategoryName" element={<RequireSubAuth element={CategorySearch} />} />
          <Route path="/search" element={<RequireSubAuth element={Search} />} />
          {/* <Route path="/search" element={<RequireSubAuth element={Search}/>} />
          <Route path="/fictions" element={<RequireSubAuth element={Search}/>} />
          <Route path="/documentaires" element={<RequireSubAuth element={Search}/>} />
          <Route path="/jeunesse" element={<RequireSubAuth element={Search}/>} />
          <Route path="/originals" element={<RequireSubAuth element={Search}/>} />
          <Route path="/courts-metrages" element={<RequireSubAuth element={Search}/>} /> */}
          <Route path="/movie/:id" element={<RequireSubAuth element={Play} />} />
          <Route path="/playVideo/:id" element={<RequireSubAuth element={PlayVideo} />} />
          <Route path="/abonnement" element={<Subscription />} />
          <Route path="/paiement" element={<Payment />} />
          <Route path="/ma-liste" element={<RequireSubAuth element={Mylist} />} />
          <Route path="/serie/:id" element={<RequireSubAuth element={PlaySerie} />} />
          <Route path="/reset-password" element={<GuestLayout element={ResetPassword} />} />
          <Route path="/reinitialisation_de_motdepasse/:userId/:token/:expires" element={<GuestLayout element={ResetPwdPage} />} />
          {/* <Route path="/test" element={<PermissionsTest />} /> */}
          <Route path="/conditions" element={<Conditions />} />
          <Route path="/politiques" element={<Politics />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;